import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  button: {
    width: "fit-content",
    marginTop: "24px",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "12px 20px",
    border: "none",
    marginTop: "auto",
  },
  wrapper: {
    margin: "48px 0px 16px",
    marginLeft: "-16px",
    marginRight: "-16px",
    "& img": {
      borderRadius: "8px",
    },
    "& h3": {
      marginTop: "24px",
      marginBottom: "16px",
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "30px",
      color: colors.lightBlack,
    },
    "& p": {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      color: colors.mediumGrey,
      marginBottom: "24px",
    },
  },
  box: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "32px",
    paddingLeft: "16px",
    paddingRight: "16px",
  }
}));

export default styles;
